
var jingdian = [
    // —————— 合肥市区（庐阳、蜀山、包河、瑶海） ——————

    [117.301488, 31.863030, '包公园'],
    [117.281655, 31.869392, '安徽博物院(旧)'],
    [117.227043, 31.808271, '安徽博物院(新)'],
    [117.174602, 31.840920, '合肥野生动物园'],
    [117.336525, 31.715629, '渡江战役纪念馆'],
    [117.297867, 31.870213, '李鸿章故居陈列馆'],
    [117.301559, 31.874693, '逍遥津公园'],
    [117.300077, 31.825802, '罍街'],
    [117.251497, 31.804255, '合柴1972文创园'],
    [117.221735, 31.786924, '合肥海洋世界'],
    [117.333815, 31.717256, '安徽名人馆'],
    [117.137860, 31.917637, '三国遗址公园'],
    [117.208622, 31.877879, '合肥植物园'],
    [117.305572, 31.779436, '骆岗中央公园'],
    [117.231072, 31.817996, '天鹅湖公园'],
    [117.294552, 31.670371, '牛角大圩生态示范园'],

    // —————— 亲子乐园 & 儿童友好型景区（重点） ——————

    [117.311617, 31.702485, '合肥融创乐园'],
    [117.140482, 31.692811, '祥源花世界'],
    [117.525540, 31.708400, '蓝山湾木艺小镇'],
    [117.225205, 31.789540, '徽园'],
    [117.409273, 31.768291, '大圩生态旅游景区'],
    [117.390608, 31.728851, '滨湖国家森林公园'],
    [117.385089, 31.740329, '方桥奇趣亲子乐园'],
    [117.310774, 31.708833, '融创茂室内儿童乐园'],
    [117.298096, 31.868369, '银泰中心Kids Land'],
    [117.236049, 31.805327, '万象城Meland Club'],
    [117.463980, 31.878049, '吾悦广场星际传奇亲子乐园'],

    // —————— 肥西县 ——————

    [117.249951, 31.518953, '三河古镇'],
    [117.013077, 31.718513, '紫蓬山国家森林公园'],
    [117.140482, 31.692811, '祥源花世界'],
    [116.908103, 31.799978, '官亭林海'],
    [116.795413, 31.727626, '铭传故里景区'],
    [117.088716, 31.704897, '肥西老母鸡家园'],
    [116.871654, 31.634167, '小井庄'],
    [117.525540, 31.708400, '蓝山湾木艺小镇'],

    // —————— 肥东县 ——————

    [117.872004, 32.157088, '岱山湖旅游度假区'],
    [117.468700, 31.694985, '长临古街景区'],
    [117.463172, 31.848677, '渡江战役总前委旧址纪念馆'],
    [117.472006, 31.627263, '四顶山景区'],
    [117.068870, 31.878278, '牌坊民族特色村寨'],
    [117.493081, 31.861182, '肥东县博物馆'],
    [117.456375, 32.105033, '老湖洞生态旅游景区'],
    [117.551655, 31.781806, '欢乐森林亲子乐园'],

    // —————— 长丰县 ——————

    // [0.000000, 0.000000, '元一双凤湖国际旅游度假区'],
    // [0.000000, 0.000000, '中国（合肥）非物质文化遗产园'],
    // [0.000000, 0.000000, '杜集鸟岛景区'],
    // [0.000000, 0.000000, '北乡双河景区'],
    // [0.000000, 0.000000, '桃花源景区'],
    // [0.000000, 0.000000, '荣事达“双创”基地景区'],
    // [0.000000, 0.000000, '伊利集团合肥工业园'],
    // [0.000000, 0.000000, '草莓小镇亲子采摘园'],

    // —————— 庐江县 ——————

    [117.108630, 31.324234, '金孔雀温泉度假村'],
    [117.348475, 31.303153, '冶父山森林公园'],
    [117.305989, 31.252653, '周瑜文化园'],
    [117.071737, 31.281349, '果树老街'],
    [117.095693, 31.264724, '虎洞生态旅游区'],
    [117.099290, 31.352361, '天鸣花海景区'],
    [117.067962, 31.248343, '三冲巢湖源'],
    [117.403229, 30.986220, '阳家墩景区'],
    [117.376087, 31.280363, '独山景区'],
    [117.202659, 31.103628, '岱鳌山旅游景区'],
    [117.334879, 31.256350, '庐江名人馆'],

    // —————— 巢湖市（县级市） ——————

    [117.463462, 31.582194, '巢湖姥山岛'],
    [117.876917, 31.655960, '紫微洞景区'],
    [117.823572, 31.560050, '东庵森林公园'],
    [117.634354, 31.659942, '李克农故居'],
    [117.855445, 31.691770, '冯玉祥旧居'],
    [117.901802, 31.605462, '巢湖市博物馆'],
    [117.548346, 31.661244, '洪家疃古村落'],
    [117.654700, 31.803062, '尖山湖逸趣园景区'],
    [117.921167, 31.685938, '半汤温泉'],
    [117.922763, 31.698005, '郁金香高地景区'],
    [117.814068, 31.617400, '龟山公园（亲子沙滩）'],
    [117.899403, 31.635274, '岠嶂山风景区'],
    [117.520454, 31.589980, '云水湾生态园（亲子采摘+萌宠）']
];

var hefei = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default hefei